
import { FETCH_REQUEST_LIST } from "../../actions/actionTypes";

const initialState = {
    data: [],
    isLoading: false,
    next:null
};

const reducer = (state=initialState, action)=>{
   // console.log("action", action)
    switch(action.type){
        case FETCH_REQUEST_LIST.REQUEST:
            return {...state, isLoading: true}
        case FETCH_REQUEST_LIST.FAILURE:
            return {...state, isLoading:false}
        case FETCH_REQUEST_LIST.SUCCESS:     
        return {
            ...state,
            data: action.obj.isLoadMore ? [...state.data,...action.obj.data] : action.obj.data,
            next: action.obj.next,
            isLoading:false
          };      
        default:
            return state
    }   
}

export default reducer;